import { Config } from '../config';

export enum DynamicScriptTarget {
  global = 'global',
  dashboards = 'dashboards',
}

export type DynamicScriptTargetTypes = 'dashboards' | 'global';

export interface DynamicScript {
  isExternal: boolean;
  src?: string;
  shortScript?: string;
  async?: boolean;
  type?: string;
  dataProps?: Array<DataProp>;
  specificTarget: DynamicScriptTarget;
}

export interface DataProp {
  name: string;
  value: string;
}

export const renderedScriptSrc: Array<string> = [];

export const dynamicScripts: Array<DynamicScript> = [
  {
    isExternal: true,
    src: `https://cdn.cookielaw.org/consent/${Config.oneTrustCookieDataValue}/OtAutoBlock.js`,
    type: 'text/javascript',
    specificTarget: DynamicScriptTarget.global,
  },
  {
    isExternal: true,
    src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    type: 'text/javascript',
    dataProps: [
      {
        name: 'data-domain-script',
        value: Config.oneTrustCookieDataValue,
      },
      {
        name: 'data-document-language',
        value: 'true',
      },
    ],
    specificTarget: DynamicScriptTarget.global,
  },
  {
    isExternal: false,
    shortScript: `function OptanonWrapper() { }`,
    specificTarget: DynamicScriptTarget.global,
  },
];
